import {colors, shadow, fontSizes, fonts, spacings} from 'style';

const style = {
    form: {
        height: '100%',
        backgroundColor: 'white',
        padding: '2rem'
        // overflowY: 'auto',
        // overflowX: 'hidden',
    },
    content: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 'calc(100% - 50px)',
        height: '100%',
        color: colors.themeDarkerGrey,
    },
    bannerColumn: {
        // padding: '0',
    },
    banner: {
        padding: '2rem 0rem 1rem 0rem',
        fontSize: fontSizes.h1,
        // lineHeight: fontSizes.h1,
    },
    logo: {
        color: colors.themeTeal,
        paddingTop: '',
        fontSize: '1.3em',
        lineHeight: '1.3em',
    },
    welcome: {
        display: 'inline',
        // color: colors.themeBlue,
        fontSize: fontSizes.h3,
        lineHeight: fontSizes.h2,
    },  
    errorLabel: {
        position: 'relative',
        margin: '0 10px -100% 0',
        float: 'right',
        right: '100%',
        bottom: '30px',
    },
    errorLabelBottom: {
    },
    field: {
        position: 'relative',
    },
    fieldCheckbox : {
        display: 'flex',
    },
    checkbox: {
        marginRight: spacings.tiny
    },
    input: {
        paddingLeft: '0px',
        borderTop: 'none',
        borderRight: 'none',
        borderLeft: 'none',
        borderBottom: '1px solid ' + colors.themeDarkerGrey,
        color: colors.themeDarkerGrey,
        boxShadow: 'none',
        borderRadius: '0',
        ...fonts.body,
    },
    inputError: {
        borderBottom: '1px solid ' + colors.errorRed,
        color: colors.errorRed,
    },
    inputLabel: {
        paddingTop: '10px',
        textAlign: 'left',
        color: colors.themeDarkerGrey,
        ...fonts.bodyL,
    },
    topRow: {
        paddingBottom: '0',
    },
    topLink: {
        ...fonts.body,
        lineHeight: '1.5em',
        paddingTop: '20px',
        paddingRight: '0px',
        paddingBottom: spacings.base,
    },
    row: {
        padding: '0',
    },
    blueButton: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: '#1c5bb7',
        color: "#fff",
        width: '330px',
        boxShadow: shadow,
        maxWidth: '100%',
    },
    tealButton: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: colors.themeTeal,
        color: '#fff',
        width: '330px',
        boxShadow: shadow,
        maxWidth: '100%',
    },
    greyButton: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: colors.themeDarkerGrey,
        color: '#fff',
        width: '330px',
        opacity: '0.50',
        boxShadow: 'rgba(0, 0, 0, 0.5) 0px 2px 4px 0px',
        maxWidth: '100%',
    },
    anchor: {
        color: colors.themeBlue,
        textDecoration: 'underline',
    },
};

export default style;



// WEBPACK FOOTER //
// ./src/modules/authentication/style.js